// CONSTANTS
export const Constants = {
  COPY_TEXT: 'COPY_TEXT_TO_CLIPBOARD',
}
// ACTION TYPES
export type ActionTypes = {
  type: typeof Constants.COPY_TEXT
  payload: string
}
// ACTION CALLS
export const Actions = {
  COPY_TEXT: (payload: string): ActionTypes => ({
    type: Constants.COPY_TEXT,
    payload,
  }),
}